import {
  BadgeColors,
  type ElementValidation,
} from '@bizzdesign/modeler/models';

export const getGroupedValidations = (data: ElementValidation[]) => {
  const errors = data.filter((item) => item.status === 'error');
  const warnings = data
    .filter((item) => item.status === 'warning')
    .map((el) => ({
      ...el,
      description: '',
    }));
  const successes = data
    .filter((item) => item.status === 'success')
    .map((el) => ({
      ...el,
      description: el.type,
    }));

  const conflicts = {
    title: 'conflicts',
    description: 'conflictsDescription',
    items: errors,
    badgeNumber: errors.length,
    badgeEmptyLabel: 'noConflicts',
    color: errors.length > 0 ? BadgeColors.RED : BadgeColors.GREEN,
    showEmptyCategoryIcon: true,
    emptyCategoryLabel: 'noConflictsDot',
  };

  const unrecognizedElements = {
    title: 'unrecognizedElements',
    description: 'unrecognizedElementsDescription',
    items: warnings,
    badgeNumber: warnings.length,
    badgeEmptyLabel: 'noElements',
    color: warnings.length > 0 ? BadgeColors.YELLOW : BadgeColors.GREEN,
    showEmptyCategoryIcon: true,
    emptyCategoryLabel: 'noUnrecognizedElements',
  };

  const newElements = {
    title: 'newElements',
    description: 'newElementsDescription',
    items: successes,
    badgeNumber: successes.length,
    badgeEmptyLabel: 'noElements',
    color: successes.length > 0 ? BadgeColors.BLUE : BadgeColors.GREEN,
    showEmptyCategoryIcon: false,
    emptyCategoryLabel: 'noNewElementsWillBePublished',
  };

  return {
    conflicts,
    unrecognizedElements,
    newElements,
  };
};
